import '../styles/style.css';

import * as MediaQuery from 'react-responsive';
import * as React from 'react';

import {
    GlancePair,
    Partner,
    PartnerMeta,
    Region,
    StudioAppConfig,
} from 'glance-datatypes';
import { GridList, GridTile } from 'material-ui/GridList';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';
import {
    green300,
    green500,
    orange300,
    orange500,
} from 'material-ui/styles/colors';
import { grey500, grey800, red300, red500 } from 'material-ui/styles/colors';
import { stateFilters, typeFilters } from '../Utils';

import Configuration from '../Configuration';
import Dialog from 'material-ui/Dialog';
import DropDownMenu from 'material-ui/DropDownMenu';
import EmptyMessage from './common/EmptyMessage';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Glance from './Glance';
import Loader from './common/Loader';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import ReactPaginate from 'react-paginate';
import RestService from '../RestService';
import Snackbar from 'material-ui/Snackbar';
import Utils from '../Utils';
import { connect } from 'react-redux';

const removeIcon = <FontIcon className='material-icons'>delete</FontIcon>;
const approveIcon = <FontIcon className='material-icons'>check</FontIcon>;
const rejectIcon = <FontIcon className='material-icons'>remove_circle_outline</FontIcon>;

const styles = {
    footer: {
        position: 'fixed',
        bottom: '0px',
        paddingBottom: '10px',
        paddingTop: '10px',
        zIndex: 10,
        backgroundColor: grey800,
        width: '90%',
        maxWidth: '1400px',
        display: 'inline-flex',
        justifyContent: 'center',
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    } as React.CSSProperties,
    footerButton: {
        maxWidth: '232px',
        flex: '1 1 0%',
        marginLeft: '10px',
        marginRight: '10px',
    } as React.CSSProperties,
    deleteButton: {
        color: red500,
        background: red300,
    } as React.CSSProperties,
    disabledButton: {
        backgroundColor: grey500,
    } as React.CSSProperties,
    loaderStyle: {
        textAlign: 'center',
    } as React.CSSProperties,
    approveButton: {
        color: green500,
        background: green300,
    } as React.CSSProperties,
    rejectButton: {
        color: orange500,
        background: orange300,
    } as React.CSSProperties,
};


enum TypeFilter {
    ALL, WALLPAPER, STORY, SPONSORED,
}

enum StateFilter {
    PENDING, APPROVED, REJECTED, REMOVED,
}

enum Action {
    APPROVE, REJECT, REMOVE,
}

function getTypeFilterString(type: TypeFilter): string {
    switch (type) {
        case TypeFilter.ALL:
            return 'Glances';
        case TypeFilter.STORY:
            return 'Stories';
        case TypeFilter.WALLPAPER:
            return 'Wallpapers';
        case TypeFilter.SPONSORED:
            return 'Sponsored';
        default:
            throw new TypeError('Unknown value ' + type);
    }
}

interface PartnerGlancesProps {
    params: any;
    history?: any;
    conf?: Configuration;
    region?: Region;
    studioAppConfig: StudioAppConfig;
    partnerMap: Map<string, Partner>;
}

interface State {
    expiryState?: Map<string, boolean>;
    partner: Partner;
    partnerMeta: PartnerMeta;
    partnerFilter?: Partner;
    partnerAutoApprove?: boolean;
    regionFilter?: Region;
    regionFilters?: Region[];
    typeFilter: TypeFilter;
    typeFilterString: string;
    expiryFilter: boolean;
    stateFilter?: StateFilter;
    filteredGlances?: GlancePair[];
    selectedGlances?: Map<string, boolean>;
    showLoader?: boolean;
    possibleActions?: Action[];
    actionClicked?: Action;
    openConfirmDialog: boolean;
    openSnackbar: boolean;
    snackbarMessage: string;
    isSponsoredEnabled: boolean;
    glancePairs?: GlancePair[];
    perPage: number;
    totalGlances: number;
    selectedPage: number;
    showActive: boolean;
    partnerMap?: Map<string, Partner>;
    searchTerm?: string;
    languages: Array<string>;
}
let timer;
class PartnerGlances extends React.Component<PartnerGlancesProps, State> {
    constructor(props: PartnerGlancesProps) {
        super(props);
        const regionFilters = [];
        let partner: Partner;
        const {params, partnerMap, studioAppConfig, history} = this.props;
        if (params && params.partnerId) {
            partner = partnerMap.get(params.partnerId);
        } else if (partnerMap.size > 0) {
            const partnerId = partnerMap.keys().next().value;
            partner = partnerMap.get(partnerId);
            history.push('/partner/' + partnerId);
        } else {
            partner = studioAppConfig.currentToken.partner;
        }
        let partnerMeta;
        studioAppConfig.partnerMetas.forEach((item) => {
            if (partner) {
                if (item.partnerId == partner.partnerId) {
                    partnerMeta = item;
                    item.supportedRegions.forEach((item) => {
                        regionFilters.push(item);
                    });
                }
            }
        });

        this.state = {
            partner,
            partnerMeta,
            regionFilter: null,
            stateFilter: StateFilter.APPROVED,
            possibleActions: [],
            partnerFilter: null,
            typeFilterString: 'Stories',
            typeFilter: TypeFilter.STORY,
            expiryFilter: false,
            openConfirmDialog: false,
            isSponsoredEnabled: false,
            glancePairs: [],
            totalGlances: 0,
            selectedPage: 1,
            showLoader: true,
            selectedGlances: new Map<string, boolean>(),
            regionFilters,
            openSnackbar: true,
            snackbarMessage: 'Please select a region first',
            showActive: false,
            perPage: 28,
            searchTerm: '',
            languages: [],
        };
    }

    componentWillMount() {
        if (!this.props.studioAppConfig) {
            this.props.history.push('/login');
        }

        const {params, partnerMap, studioAppConfig, history} = this.props;

        if (params && params.region) {
            const region: Region = parseInt(this.props.params.region);
            const filter: StateFilter = params.filter ? parseInt(params.filter) : StateFilter.APPROVED;
            const typeFilter: TypeFilter = params.type ? parseInt(params.type) : TypeFilter.STORY;

            this.setState({
                ...this.state,
                glancePairs: [],
                regionFilter: region,
                openSnackbar: true,
                snackbarMessage: 'Loading glances for region ' + Utils.getReadableRegionName(region) + ' ...',
                stateFilter: filter,
                typeFilter,
                typeFilterString: getTypeFilterString(typeFilter),
            }, () => {
                this.fetchGlances(true);
            });

        } else if (this.state.regionFilters.length == 1) {
            const region = this.state.regionFilters[0];

            this.props.history.push('/partner/' + this.state.partner.partnerId + '/published/' + region + '/' + Utils.getReadableRegionName(region) + '/'
                + StateFilter.APPROVED + '/' + StateFilter[StateFilter.APPROVED]);
            window.location.reload();
        }

    }

    componentDidMount() {
        const possibleActions = this.getPossibleActions();
        this.setState({
            ...this.state,
            possibleActions,
        });
    }

    pushFilterUrl(region: Region, state: StateFilter, type: TypeFilter) {
        const url = '/partner/' + this.state.partner.partnerId + '/published/' + region + '/' + Utils.getReadableRegionName(region) + '/'
            + state + '/' + StateFilter[state] + '/' + type + '/' + TypeFilter[type];
        this.props.history.push(url);
    }

    searchHandler = (event: any) => {
      if (timer) {
          clearTimeout(timer);
      };
      this.setState({
          ...this.state,
          searchTerm: event.target.value,
      });
      timer = setTimeout(() => {
             this.fetchGlances(true);
      }, 800);
    };

    searchButton = () => {
        this.fetchGlances(true);
    };

    fetchGlances = (resetPage) => {
        const { regionFilter, partner, perPage, selectedPage, expiryFilter, stateFilter, typeFilter, searchTerm, languages } = this.state;
        const type = typeFilters[typeFilter];
        const state = stateFilters[stateFilter];
        const offset = resetPage ? 0 : (selectedPage - 1) * perPage;

        const payload = {
            limit: perPage,
            offset,
            expired: expiryFilter,
            state,
            type,
            region: regionFilter,
            partner,
            search: searchTerm,
            languages
        };
        this.setState({
            ...this.state,
            showLoader: true,
            selectedPage: resetPage ? 1 : selectedPage,
            selectedGlances: new Map<string, boolean>(),
        });

        RestService.getPartnerPublishedGlances(payload).then((response: any) => {

            this.setState({
                ...this.state,
                glancePairs: response.pairs,
                showLoader: false,
                totalGlances: response.count,
                snackbarMessage: 'Glances loaded',
                openSnackbar: true,
            });


        }).catch(error => {
            this.setState({
                ...this.state,
                snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.',
                openSnackbar: true,
                showLoader: false,
            });
        });
    }


    handleRegionFilterChange = (event: any, index: number, value: Region) => {
        this.pushFilterUrl(value, StateFilter.APPROVED, this.state.typeFilter);
        window.location.reload();
    }

    handleTypeFilterChange = (event: any, index: number, value: TypeFilter) => {

        this.setState({
            ...this.state,
            typeFilter: value,
        }, () => this.fetchGlances(true));
    }

    handleExpiryFilterChange = (event: any, index: number, value: boolean) => {
        this.setState({
            ...this.state,
            expiryFilter: value,
        }, () => this.fetchGlances(true));
    }

    handleLanguageFilterChange = (event: any, index: number, value: string) => {
        if (value) {
          this.setState({
            ...this.state,
            languages: [value],
        }, () => this.fetchGlances(true));
        } else {
          this.setState({
            ...this.state,
            languages: []
          })
        }
    }

    handleStateFilterChange = (event: any, index: number, value: StateFilter) => {
        this.pushFilterUrl(this.state.regionFilter, value, this.state.typeFilter);
        const possibleActions = this.getPossibleActions(value);

        this.setState({
            ...this.state,
            stateFilter: value,
            possibleActions,
        }, () => { this.fetchGlances(true); });
    }



    getPossibleActions = (stateFilter = this.state.stateFilter) => {

        let possibleActions: Action[];
        switch (stateFilter) {
            case StateFilter.APPROVED:
                possibleActions = [Action.REMOVE];
                break;
            case StateFilter.PENDING:
                possibleActions = [Action.APPROVE, Action.REJECT];
                break;
            case StateFilter.REJECTED:
            case StateFilter.REMOVED:
            default:
                possibleActions = [];
        }
        return possibleActions;
    }

    onSelectGlance = (element: GlancePair, selected: boolean) => {
        const newMap = new Map<string, boolean>(this.state.selectedGlances);
        if (selected) {
            newMap.set(element.data.glanceId, true);
        } else {
            newMap.delete(element.data.glanceId);
        }

        this.setState({
            ...this.state,
            selectedGlances: newMap,
        });
    }

    handleAction = (action: Action) => {
        this.setState({
            ...this.state,
            actionClicked: action,
            openConfirmDialog: true,
        });
    }

    handleActionConfirm = (action: Action) => {
        const selectedIds: string[] = [];
        this.state.selectedGlances.forEach((value: boolean, glanceId: string) => {
            selectedIds.push(glanceId);
        });
        this.setState({
            ...this.state,
            snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...',
            openSnackbar: true,
        });
        switch (action) {
            case Action.REMOVE:
                RestService.removeGlances(this.state.regionFilter, selectedIds, this.state.partner, (success) => {
                    this.handleActionComplete(action, success);
                });
                break;
            case Action.APPROVE:
                RestService.approveGlances(this.state.regionFilter, selectedIds, this.state.partner, (success) => {
                    this.handleActionComplete(action, success);
                });
                break;
            case Action.REJECT:
                RestService.rejectGlances(this.state.regionFilter, selectedIds, this.state.partner, (success) => {
                    this.handleActionComplete(action, success);
                });
                break;
            default:
                break;
        }
    }

    handleActionComplete = (action: Action, success: boolean) => {
        if (success) {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...',
                openConfirmDialog: false,
                selectedGlances: new Map<string, boolean>(),
            }, () => {
                this.fetchGlances(true);
            });

        } else {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.',
                openConfirmDialog: false,
            });
        }
    }

    closeConfirmDialog = () => {
        this.setState({
            ...this.state,
            openConfirmDialog: false,
        });
    }

    closeSnackbar = () => {
        this.setState({
            ...this.state,
            openSnackbar: false,
        });
    }

    onPageChange = (page) => {
        this.setState({
            ...this.state,
            selectedPage: page.selected + 1,
            selectedGlances: new Map<string, boolean>(),
        }, () => {
            this.fetchGlances(false);
        });
    }

    handleSelectAllClick = () => {
        const newMap = new Map<string, boolean>();
        for (let pair of this.state.glancePairs) {
            newMap.set(pair.data.glanceId, true);
        }

        this.setState({
            ...this.state,
            selectedGlances: newMap,
        });
    }

    isTranssionPartner = () =>
        this.state.partner && this.state.partner.name === 'Transsion';

    render() {
        const actions = [];
        const { selectedPage, glancePairs, regionFilters, showLoader, totalGlances, perPage } = this.state;
        let paginationElement = [];
        if (totalGlances > perPage) {

            paginationElement.push(
                <ReactPaginate
                    previousLabel='Previous'
                    nextLabel='Next'
                    breakLabel={<span className='gap'>...</span>}
                    pageCount={Math.ceil(totalGlances/perPage)}
                    onPageChange={this.onPageChange}
                    forcePage={selectedPage}
                    containerClassName='pagination'
                    previousLinkClassName='previous_page'
                    nextLinkClassName='next_page'
                    disabledClassName='disabled'
                    activeClassName='active'
                />,

            );
        }
        actions.push(
            <FlatButton label='Cancel' primary={true}
                onClick={this.closeConfirmDialog} />,
        );
        actions.push(
            <FlatButton label={'Yes, ' + Action[this.state.actionClicked]} primary={true}
                onClick={() => this.handleActionConfirm(this.state.actionClicked)} />,
        );
        return (
            <div>
                {
                    !this.state.regionFilter ?
                        <Toolbar style={{ marginTop: '2%' }}>
                            <ToolbarGroup firstChild={true}>
                                <DropDownMenu value={this.state.regionFilter}
                                    onChange={this.handleRegionFilterChange}>
                                    {
                                        regionFilters.length > 1 ?
                                            <MenuItem value={null} primaryText={'Click here to select your region'} />
                                            : ''
                                    }
                                    {
                                        regionFilters.map((item) => {
                                            return <MenuItem value={item} primaryText={Utils.getReadableRegionName(item)} key={item} />;
                                        })
                                    }
                                </DropDownMenu>
                            </ToolbarGroup>
                        </Toolbar> :
                        <div>
                            <Toolbar style={{ marginTop: '2%' }} >
                                <ToolbarGroup firstChild={true}>
                                    <ToolbarTitle text='Filters' style={{ marginLeft: '10px' }} />
                                    <ToolbarSeparator />
                                    <DropDownMenu value={this.state.regionFilter}
                                        onChange={this.handleRegionFilterChange}>
                                        {
                                            regionFilters.length > 1 && !this.state.regionFilter ?
                                                <MenuItem value={null} primaryText={'Select your region'} />
                                                : ''
                                        }

                                        {
                                            regionFilters.map((item) => {
                                                return <MenuItem value={item} primaryText={Utils.getReadableRegionName(item)} key={item} />;
                                            })
                                        }
                                    </DropDownMenu>
                                    {
                                        this.state.partnerMeta.autoApprove ?
                                            <DropDownMenu value={this.state.stateFilter}
                                                onChange={this.handleStateFilterChange}>
                                                <MenuItem value={StateFilter.APPROVED} primaryText='Active Glances' />
                                                <MenuItem value={StateFilter.REMOVED} primaryText='Removed Glances' />
                                            </DropDownMenu> :
                                            <DropDownMenu value={this.state.stateFilter}
                                                onChange={this.handleStateFilterChange}>

                                                <MenuItem value={StateFilter.PENDING} primaryText='Pending Approval' />
                                                <MenuItem value={StateFilter.APPROVED} primaryText='Approved Glances' />
                                                <MenuItem value={StateFilter.REJECTED} primaryText='Rejected Glances' />
                                                <MenuItem value={StateFilter.REMOVED} primaryText='Removed Glances' />
                                            </DropDownMenu>
                                    }
                                    <MediaQuery query='(min-device-width: 1224px)'
                                        style={{ marginTop: '2%' }}>
                                        <DropDownMenu value={this.state.typeFilter}
                                            onChange={this.handleTypeFilterChange}>
                                            <MenuItem value={TypeFilter.ALL} primaryText='Everything' />
                                            <MenuItem value={TypeFilter.STORY} primaryText='Stories' />
                                            <MenuItem value={TypeFilter.WALLPAPER} primaryText='Wallpapers' />
                                            {this.state.partnerMeta && this.state.partnerMeta.isSponsoredEnabled ?
                                                <MenuItem value={TypeFilter.SPONSORED} primaryText='Sponsored' /> : ''}
                                        </DropDownMenu>
                                        <DropDownMenu value={this.state.expiryFilter}
                                            onChange={this.handleExpiryFilterChange}>
                                            <MenuItem value={false} primaryText='Active Glances' />
                                            <MenuItem value={true} primaryText='Expired Glances' />
                                        </DropDownMenu>
                                        {
                                          this.isTranssionPartner() ? (
                                            <DropDownMenu
                                              value={this.state.languages.length > 0 ? this.state.languages[0] : null}
                                              onChange={this.handleLanguageFilterChange}
                                             >
                                               <MenuItem value={null} primaryText='Language' />
                                                {
                                                  this.props.studioAppConfig.glanceLanguages.map((language) => (
                                                    <MenuItem
                                                      key={language.id}
                                                      value={language.id}
                                                      primaryText={language.displayName}
                                                    />
                                                  ))
                                                }
                                            </DropDownMenu>
                                          ) : null
                                        }
                                        {
                                          this.isTranssionPartner() ? (
                                            <div className={`wrap partner transsion`}>
                                              <div className='search'>
                                                <input type='text'
                                                  value={this.state.searchTerm}
                                                  onChange={this.searchHandler}
                                                  placeholder='Search...'
                                                  className='searchTerm'
                                                />
                                                <div>{totalGlances}</div>
                                                <button type='submit' className='searchButton' onClick={this.searchButton}>
                                                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'>
                                                    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>
                                          ) : null
                                        }
                                    </MediaQuery>
                                </ToolbarGroup>
                                <MediaQuery query='(min-device-width: 1224px)'>
                                    {
                                        this.state.stateFilter == StateFilter.PENDING
                                            || this.state.stateFilter == StateFilter.APPROVED ?
                                            <ToolbarGroup >
                                                <RaisedButton label={'Select All ' + this.state.typeFilterString}
                                                    primary={true} onClick={this.handleSelectAllClick} disabled={glancePairs.length === 0 || showLoader} />
                                            </ToolbarGroup> : ''
                                    }
                                </MediaQuery>
                            </Toolbar>
                            <MediaQuery query='(max-device-width: 1224px)'>
                                <Toolbar style={{ marginTop: '2%' }} >
                                    <ToolbarGroup firstChild={true}
                                        style={{ margin: 0 }}>
                                        <DropDownMenu value={this.state.typeFilter}
                                            onChange={this.handleTypeFilterChange}
                                            style={{ marginRight: 0 }}>
                                            <MenuItem value={TypeFilter.ALL} primaryText='Everything' />
                                            <MenuItem value={TypeFilter.STORY} primaryText='Stories' />
                                            <MenuItem value={TypeFilter.WALLPAPER} primaryText='Wallpapers' />
                                            {this.state.partnerMeta && this.state.partnerMeta.isSponsoredEnabled ?
                                                <MenuItem value={TypeFilter.SPONSORED} primaryText='Sponsored' /> : ''}
                                        </DropDownMenu>
                                        <DropDownMenu value={this.state.expiryFilter}
                                            onChange={this.handleExpiryFilterChange}
                                            style={{ marginRight: 0 }}>
                                            <MenuItem value={false} primaryText='Active Glances' />
                                            <MenuItem value={true} primaryText='Expired Glances' />
                                        </DropDownMenu>
                                        {
                                          this.isTranssionPartner() ? (
                                            <DropDownMenu
                                              value={this.state.languages.length > 0 ? this.state.languages[0] : null}
                                              onChange={this.handleLanguageFilterChange}
                                             >
                                               <MenuItem value={null} primaryText='Language' />
                                                {
                                                  this.props.studioAppConfig.glanceLanguages.map((language) => (
                                                    <MenuItem
                                                      key={language.id}
                                                      value={language.id}
                                                      primaryText={language.displayName}
                                                    />
                                                  ))
                                                }
                                            </DropDownMenu>
                                          ) : null
                                        }
                                        {
                                          this.isTranssionPartner() ? (
                                            <div className={`wrap partner transsion`}>
                                              <div className='search'>
                                                <input type='text'
                                                  value={this.state.searchTerm}
                                                  onChange={this.searchHandler}
                                                  placeholder='Search...'
                                                  className='searchTerm'
                                                />
                                                <div>{totalGlances}</div>
                                                <button type='submit' className='searchButton' onClick={this.searchButton}>
                                                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'>
                                                    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>
                                          ) : null
                                        }
                                        {
                                          this.state.stateFilter == StateFilter.PENDING
                                            || this.state.stateFilter == StateFilter.APPROVED
                                              ? <RaisedButton
                                                  label={'Select All ' + this.state.typeFilterString}
                                                  primary={true}
                                                  onClick={this.handleSelectAllClick}
                                                  disabled={glancePairs.length === 0 || showLoader} />
                                              : ''
                                        }
                                    </ToolbarGroup>
                                </Toolbar>
                            </MediaQuery>
                        </div>
                }
                {this.state.regionFilter && (
                    <Loader show={showLoader} message='Loading Glances'>
                        {this.state.glancePairs && this.state.glancePairs.length > 0 ?
                            <div>
                                <MediaQuery query='(min-device-width: 1224px)'>
                                    <GridList
                                        style={{ width: '100%', margin: '0 auto', marginTop: '2%' }}
                                        cols={4}
                                        padding={15}
                                        cellHeight='auto'>
                                        {
                                            this.state.glancePairs.map((element) => {
                                                return (<GridTile key={element.data.glanceId}
                                                    containerElement={
                                                        <Glance glance={element}
                                                            selected={this.state.selectedGlances.get(element.data.glanceId)}
                                                            partner={this.state.partner} region={this.state.regionFilter}
                                                            onSelect={(selected: boolean) => this.onSelectGlance(element, selected)} />
                                                    }>
                                                </GridTile>);
                                            })
                                        }
                                    </GridList>
                                </MediaQuery>
                                <MediaQuery query='(max-device-width: 1224px)'>
                                    <GridList
                                        style={{ width: '100%', margin: '0 auto', marginTop: '2%' }}
                                        cols={2}
                                        cellHeight='auto'>
                                        {
                                            this.state.glancePairs.map((element) => {
                                                return (<GridTile key={element.data.glanceId}
                                                    containerElement={
                                                        <Glance glance={element}
                                                            selected={this.state.selectedGlances.get(element.data.glanceId)}
                                                            partner={this.state.partner} region={this.state.regionFilter}
                                                            onSelect={(selected: boolean) => this.onSelectGlance(element, selected)} />
                                                    }>
                                                </GridTile>);
                                            })
                                        }
                                    </GridList>
                                </MediaQuery>
                            </div> : <EmptyMessage message='No glances for selected filters'></EmptyMessage>
                        }
                    </Loader>
                )
                }
                {
                    !this.state.regionFilter ?
                        <EmptyMessage message={this.state.snackbarMessage}></EmptyMessage>
                        : ''
                }
                {totalGlances > perPage && <div id='react-paginate'>
  <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                pageRangeDisplayed={3}
                marginPagesDisplayed={3}
                breakLabel={<span className='gap'>...</span>}
                pageCount={Math.ceil(totalGlances/perPage)}
                onPageChange={this.onPageChange}
                forcePage= {selectedPage -1}
                activeClassName='active'
                />


                    </div>}

                {
                    this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
                        <div style={styles.footer}>
                            <RaisedButton
                                icon={removeIcon}
                                label={'Remove Selected (' + this.state.selectedGlances.size + ')'}
                                primary
                                buttonStyle={this.state.possibleActions.indexOf(Action.REMOVE) < 0 ? styles.disabledButton : styles.deleteButton}
                                style={styles.footerButton}
                                onClick={() => this.handleAction(Action.REMOVE)}
                                disabled={this.state.possibleActions.indexOf(Action.REMOVE) < 0}
                            />
                            {this.state.partnerMeta.autoApprove ? '' :
                                <RaisedButton
                                    label={'Approve Selected (' + this.state.selectedGlances.size + ')'}
                                    icon={approveIcon}
                                    primary
                                    buttonStyle={this.state.possibleActions.indexOf(Action.APPROVE) < 0 ? styles.disabledButton : styles.approveButton}
                                    style={styles.footerButton}
                                    onClick={() => this.handleAction(Action.APPROVE)}
                                    disabled={this.state.possibleActions.indexOf(Action.APPROVE) < 0}
                                />
                            }
                            {this.state.partnerMeta.autoApprove ? '' :
                                <RaisedButton
                                    label={'Reject Selected (' + this.state.selectedGlances.size + ')'}
                                    icon={rejectIcon}
                                    primary
                                    buttonStyle={this.state.possibleActions.indexOf(Action.REJECT) < 0 ? styles.disabledButton : styles.rejectButton}
                                    style={styles.footerButton}
                                    onClick={() => this.handleAction(Action.REJECT)}
                                    disabled={this.state.possibleActions.indexOf(Action.APPROVE) < 0}
                                />
                            }
                        </div> : ''
                }

                <Dialog modal={false}
                    open={this.state.openConfirmDialog}
                    onRequestClose={this.closeConfirmDialog}

                    actions={actions}
                >
                    Please confirm that you want to {Action[this.state.actionClicked]} these glances.
                </Dialog>
                <Snackbar open={this.state.openSnackbar} message={this.state.snackbarMessage} onRequestClose={this.closeSnackbar} autoHideDuration={2000} />
            </div>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};

export default connect(mapStateToProps)(PartnerGlances);




// WEBPACK FOOTER //
// ./src/components/PartnerGlances.tsx